export const PERF_HACK_IS_CLOSED_GLOBAL = 'PERF_HACK_IS_CLOSED_GLOBAL';
export const getPerfHackIsClosed = (): boolean => {
  if (process.env.JS_ENV_CLIENT) {
    return !!window[PERF_HACK_IS_CLOSED_GLOBAL];
  }

  return false;
};
